import React from "react";
import styles from "./ServicesM.module.css";

export default function Services() {
  return <div className="lightSectionContent" id="services">
      <div className="darkSectionTitle">
        <h1>Nasze usługi</h1>
      </div>
      <div className={styles.sectionDescription}>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/service.webp`} alt="wymiana oleju" className={styles.imageItem} />
          <p className={styles.descriptionItem}>Wymiana oleju i filtrów</p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/service.webp`} alt="naprawa zawieszenia" className={styles.imageItem} />
          <p className={styles.descriptionItem}>Naprawa zawieszenia</p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/service.webp`} alt="układ hamulcowy" className={styles.imageItem} />
          <p className={styles.descriptionItem}>Naprawa układu hamulcowego</p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/service.webp`} alt="układ kieerowniczy" className={styles.imageItem} />
          <p className={styles.descriptionItem}>
            Naprawa układu kierowniczego
          </p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/service.webp`} alt="koontorla płynów" className={styles.imageItem} />
          <p className={styles.descriptionItem}>
            Kontrola płynów eksploatacyjnych.
          </p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/service.webp`} alt="diagnostyka komputerowa" className={styles.imageItem} />
          <p className={styles.descriptionItem}>Diagnostyka komputerowa</p>
        </div>
      </div>
    </div>;
}
